import { VueController } from 'util/vue_controller'

// Connects to data-controller="pricing-performance-breakdown"
export default class extends VueController {
  static vueComponent = 'pricing-performance-breakdowns'

  static targets = ['tableBody']

  static values = {
    pricingPrograms: Array,
    chains: Array
  }

  get props () {
    return {
      chains: this.chainsValue,
      pricingPrograms: this.pricingProgramsValue
    }
  }

  get vueTarget () {
    return this.tableBodyTarget
  }
}
